
import DeliveryAddressRow from './DeliveryAddressRow.vue'
import AddDeliveryAddressForm from './AddDeliveryAddressForm.vue'
import api from '@/store/api'

export default {
  name: 'DeliveryAddressesSection',
  components: {
    DeliveryAddressRow,
    AddDeliveryAddressForm
  },
  props: {
    deliveryAddresses: {
      type: Array,
      required: true,
      default: () => []
    },
    conversationUserPairId: {
      type: [String, Number],
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canAdd: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedDeliveryAddressForEdit: null,
      isLoading: false
    }
  },
  computed: {
    hasDeliveryAddresses() {
      return this.deliveryAddresses && this.deliveryAddresses.length > 0
    }
  },
  methods: {
    editDeliveryAddress(deliveryAddress) {
      this.selectedDeliveryAddressForEdit = deliveryAddress
    },
    removeDeliveryAddress(deliveryAddress) {
      if (confirm('Are you sure you want to remove this delivery address?')) {
        this.isLoading = true
        api
          .call(
            'DELETE',
            `conversation_user_pairs/${this.conversationUserPairId}/customer/delivery_address/${deliveryAddress.id}`
          )
          .then(() => {
            this.isLoading = false
            this.$emit('address-removed')
          })
          .catch(() => {
            this.isLoading = false
          })
      }
    },
    onDeliveryAddressSaved() {
      this.selectedDeliveryAddressForEdit = null
      this.$emit('address-saved')
    },
    onDeliveryAddressEditCanceled() {
      this.selectedDeliveryAddressForEdit = null
    }
  }
}
